<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="商品名称" outlined v-model="query.goodsName">
								</v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-select :items="statusList" v-model="query.status"
								item-text="text" item-value="value" label="状态" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-2">
							<v-btn small @click="showAddDialog" color="info">添加商品</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					{{ classStatusName(item.status) }}
				</template>
				<template v-slot:item.masterImg="{item}">
					<v-avatar rounded class="my-1" style="cursor: pointer;">
						<v-img v-if="item.masterImg" :src="imgPrev + item.masterImg" width="50" height="50" @click="showImageViewer(item.masterImg)"></v-img>
					</v-avatar>
				</template>
				
				<template v-slot:item.action="{item}">
					<v-btn @click.stop="showUpdate(item)" color="info" small>修改</v-btn>	
					
					<v-btn v-if="item.status == '1'" @click.stop="changeStatus(item,'0')" color="error" small class="ml-2">作废</v-btn>
					
					<v-btn v-if="item.status == '0'" @click.stop="changeStatus(item,'1')" color="error" small class="ml-2">启用</v-btn>
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="10"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 添加dialog -->
		<v-dialog title="添加商品" v-model="add.dialog" max-width="500">
			<v-card min-height="300">
				<v-card-title>
					<span>添加商品信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="add.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="商品名称" v-model="add.goods.goodsName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12" v-if="!this.add.goods.masterImg">
							<cutImageUpload :show="true" title="上传商品图片" @success="addUploadSuccess"></cutImageUpload>
						</v-col>
						<v-col cols="12" v-if="add.goods.masterImg">
							<v-img :src="imgPrev+add.goods.masterImg" height="200" width="200">
								<v-app-bar flat color="rgba(0, 0, 0, 0.2)" height="25">
									<v-spacer></v-spacer>
									<v-btn color="white" x-small icon @click="add.goods.masterImg=''">
										<v-icon color="red">mdi-close-circle</v-icon>
									</v-btn>
								</v-app-bar>
							</v-img>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddClass" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 修改dialog -->
		<v-dialog title="修改商品信息" v-model="update.dialog" max-width="500" persistent>
			<v-card>
				<v-card-title>
					<span>修改商品信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="update.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12" class="mt-3">
							<v-text-field label="商品名称" v-model="update.goods.goodsName" dense outlined></v-text-field>
						</v-col>

						<v-col cols="12" v-if="!update.goods.masterImg">
							<cutImageUpload :show="true" title="上传商品图片" @success="editUploadSuccess"></cutImageUpload>
						</v-col>
						<v-col cols="12" v-if="update.goods.masterImg">
							<v-img :src="imgPrev+update.goods.masterImg" height="200" width="200">
								<v-app-bar flat color="rgba(0, 0, 0, 0.2)" height="25">
									<v-spacer></v-spacer>
									<v-btn color="white" x-small icon @click="update.goods.masterImg=''">
										<v-icon color="red">mdi-close-circle</v-icon>
									</v-btn>
								</v-app-bar>
							</v-img>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="update.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdateGoods" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 图片预览 -->
		<imageViewer :show="imageViewerDialog.show" :imgSrc="imageViewerDialog.imgSrc" :imgWidth="imageViewerDialog.imgWidth" 
			:imgHeight="imageViewerDialog.imgHeight" @cancel="imageViewerDialog.show=false"></imageViewer>
		
	</v-card>
</template>

<script>
	import * as qiniu from 'qiniu-js'
	import global from '../../../config/global'
	import storage from "../../../config/storage"
	import utils from '../../../config/utils'
	import cutImageUpload from '../../../components/cut_image_upload.vue'
	import imageViewer from "../../../components/image_viewer.vue"
	export default {
		name: "goods-list",
		components:{ cutImageUpload,imageViewer },
		data() {
			return {
				imgPrev: global.config.imgPre,
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: 'ERP管理中心',
						disabled: true
					},
					{
						text: '商品管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '商品ID',
							value: 'id',
							sortable: false
						},
						{
							text: '商品名称',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '主图',
							value: 'masterImg',
							sortable: false
						},
						
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				statusList:[{text:'全部',value:''},{text:'正常',value:'1'},{text:'作废',value:'0'}],
	
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					goodsName: "",
					status:"1",
	
				},
				add: {
					dialog: false,
					goods: {
						masterImg:"",
						goodsName: "",
					},
				},
				update: {
					dialog: false,
					goods: {
						id:"",
						goodsName: "",
						status:"",
						masterImg:"",
					}
				},
				imageViewerDialog:{
					show:false,
					imgSrc:"",
					imgWidth:"400",
					imgHeight:"400",
				}
			
			}
		},
		created() {
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			addUploadSuccess(res){
				// 主图上传完成
				console.log(res);
				this.add.goods.masterImg = res.key;
			},
			showImageViewer(imgSrc){
				this.imageViewerDialog.imgSrc = imgSrc;
				this.imageViewerDialog.show=true;
			},
			showAddDialog() {
				this.add.dialog = true;
				
				// 清空add历史数据
				this.add.goods.goodsName = "";
				
				// 清空上传组件数据
				this.upload.uploadedCount = 0;
				this.upload.files = [];
				this.upload.imgList = [];
				this.upload.waitUploadList = [];
				
			},
			editUploadSuccess(res){
				this.update.goods.masterImg = res.key;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/goods/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.goodsName) {
					url += "&goodsName=" + this.query.goodsName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			classStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			classStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddClass() {

				if (!this.add.goods.goodsName) {
					this.$noty.error('商品名称不能为空');
					return
				}
				
				if(!this.add.goods.masterImg){
					this.$noty.error('请上传商品图片');
					return
				}
				
				let imgList = []; // 上传的图片KEY
				imgList.push(this.add.goods.masterImg);
				
		
			
				// api
				const that = this;
				let url = `/erp/goods/create`;
				let postData = {...this.add.goods};
				postData.imgList = imgList;
				
			

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			showUpdate(item) {
				
				console.log(item);
				this.update.dialog = true;
				this.update.goods.id = item.id;
				this.update.goods.goodsName = item.goodsName;
				this.update.goods.status = item.status;
				this.update.goods.masterImg =  item.masterImg;
			},
			submitUpdateGoods() {

				if (!this.update.goods.id) {
					this.$noty.error('ID不能为空');
					return
				}
				if (!this.update.goods.goodsName) {
					this.$noty.error('商品名称不能为空');
					return
				}
				
				if(!this.update.goods.masterImg){
					this.$noty.error('请上传商品图片');
					return
				}
				
				let imgList = []; // 上传的图片KEY
				imgList.push(this.update.goods.masterImg);
	
				
				// api
				const that = this;
				let url = `/erp/goods/update`;
			
				// parameters
				
				const updateData = {
					...this.update.goods
				}
				updateData.imgList = imgList;
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			// 修改商品状态
			changeStatus(item,newStatus){
				// api
				const that = this;
				let url = `/erp/goods/status`;
							
				// parameters
				
				const updateData = {
					id:item.id,
					status:newStatus
				}
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			}
		}
	}
</script>

<style>
</style>
